import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Invoice } from "@common/types/invoice";
import { getInvoiceSentByLabel } from "@common/helpers/domains/invoices/invoiceSentInfo";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";

export const SentByCell = memo(
    ({ row }: CellContext<ViewTableFeatures, Invoice, Invoice["sentInfo"]>) => (
        <ViewTableCell>
            {getInvoiceSentByLabel(row.original.sentInfo)}
        </ViewTableCell>
    ),
);
